/**
 * Réglages de l'écran client « saisie » (mode Client, la fiche saisie à la Caisse) : style, assombrissement du fond, taille du gant,
 * boîte de dialogue. Ils sont enregistrés comme ceux d'un fond du bandeau (le serveur ne connaît pas leur contenu) : voir
 * fonds/reglages.js pour la description des types et la résolution des valeurs.
 *
 * Deux listes d'images de la galerie servent aussi, enregistrées de la même façon (une image chacune) : l'image de fond et le gant.
 */

/** Identifiants enregistrés côté serveur (même table que les fonds du bandeau : lettres minuscules, chiffres, _ et -). */
export const ID_REGLAGES = "saisie_client";
export const ID_IMAGE_FOND = "saisie_client_fond";
export const ID_IMAGE_GANT = "saisie_client_gant";

/** Styles disponibles (le détail de chaque style est dans themes.js) ; le premier est celui d'origine. */
export const OPTIONS_THEME = [
    {valeur: "finalfantasy", libelle: "Final Fantasy (fenêtres bleues, gant, boîte de dialogue)"},
    {valeur: "classique", libelle: "Classique (verre sombre, accent vert)"},
];

export const REGLAGES_SAISIE = {
    theme: {
        type: "choix", libelle: "Style", defaut: "finalfantasy", options: OPTIONS_THEME,
        aide: "L'habillage de toute la page : fenêtres, couleurs, curseur. D'autres styles pourront s'ajouter.",
    },
    assombrissement: {
        type: "nombre", libelle: "Assombrir l'image de fond", min: 0, max: 90, pas: 5, defaut: 45, unite: "%",
        aide: "Sans effet sans image de fond. Plus c'est sombre, mieux le texte se lit : à régler selon l'image.",
    },
    gant: {
        type: "nombre", libelle: "Taille du gant", min: 50, max: 140, pas: 10, defaut: 100, unite: "%",
        aide: "Le curseur qui pointe le champ en cours de saisie (le gant d'origine ou l'image choisie).",
    },
    dialogue: {
        type: "interrupteur", libelle: "Afficher le message en bas de l'écran", defaut: true,
        aide: "« Merci de vérifier vos informations… » : décocher pour ne garder que la fiche.",
    },
};

/** Première image d'une liste d'images enregistrées (l'objet {id, url, nom}), ou null. */
export const premiereImage = liste => (Array.isArray(liste) && liste.length ? liste[0] : null);
